module.exports = __webpack_public_path__ + "static/media/brand-story-meaning6.82bc2594.png";